import { gql } from "@apollo/client";

export const VALIDAR_VISITA_CERO = gql`
  query validarVisitaCero($idEvaluacion : Int!) {
    validarVisitaCero(idEvaluacion : $idEvaluacion) {
      success
      error
      valorEsperado 
    }
  }
`;